module.exports = __webpack_public_path__ + "img/bg-smart-home-2.975d8868.jpg";